<script setup>
import { isUserLoggedIn } from '@/router/utils'

// RM-223: `guestUserGroup` is the "resume joining this group" funnel value, set
// when a logged-OUT visitor lands on /{group}/activate|join|friends. It must
// only redirect a guest. A logged-IN member is no longer a guest — without this
// guard they get bounced to /{group}/activate every time they hit /home (or "/"
// after logout), an inescapable loop that made approved enterprise members
// unable to reach the app. Clear the stale value once the user is authenticated.
let guestUserGroup = JSON.parse(localStorage.getItem('guestUserGroup'))
if (guestUserGroup && !isUserLoggedIn()) {
  window.location.href = `${window.location.origin}${guestUserGroup.joinUrl}`
} else if (guestUserGroup) {
  localStorage.removeItem('guestUserGroup')
}

let homeRedirectPath = localStorage.getItem('homeRedirectPath')
if (homeRedirectPath) {
  router.push({ path: homeRedirectPath })
}
</script>

<template>
  <div>
    <section class="home-masthead">
      <div class="content-wrapper">
        <div class="masthead-content mt-2 mb-0 pl-0 pr-0">
          <HomeMasthead
            :home-page="true"
            :join-page="true"
            :verified-element="true"
            :book-btn="false"
            :learn-more-first="true"
            activate-text="Inquire"
            :ios-app-available="false"
            :show-activate-sub-text="true"
          />
        </div>
      </div>
    </section>
    <VDivider thickness="2" />
    <DiscoverContent />
  </div>
</template>

<style lang="scss" scoped>
@use "@core/scss/pages/misc.scss";

a {
  cursor: pointer;
}


.masthead-content {
  padding: 0 1rem; // matches the 16px gutter of the favorites column below
  margin: 1rem 0;
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
